import React from 'react';
import "./Styles/UserProfile.css";
import NavBar from '../NavBar';
import OrderCheckout from './Components/OrderCheckout/OrderCheckout';
//import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
//import Footer from '../Footer';
import UserInfoProvider from './Components/Context/UserInfoContext';
import MedicalContextProvider from './Components/Context/MedicalContext';
import BasketContextProvider from './Components/Context/BasketContext';

function OrderCheckoutRoute() {
    return (
        <UserInfoProvider>
            <MedicalContextProvider>
                <BasketContextProvider>
                <div className="OrderCheckoutRoutePage">
                    <div className="OrderCheckoutRouteNavBar">      
                        <NavBar/>
                    </div>
                    <div className="OrderCheckoutRoute">
                        <OrderCheckout/>
                    </div>
                    {/*<div className="OrderCheckoutRouteFooter">      
                        <Footer/>
                    </div>*/}
                </div>
                </BasketContextProvider>
            </MedicalContextProvider>
        </UserInfoProvider>
    );
}

export default OrderCheckoutRoute;